import { z } from "zod";

import { collectionCompletedStateEnum } from "../../enums/collection/collectionCompletedStateEnum";
import { imagesSchema } from "../imagesSchema";

export const baseCollectionSchema = z.object({
  available_at: z.iso.datetime().nullable(),
  desc: z.string(),
  ends_at: z.iso.datetime().nullable(),
  filter: z.enum(["downloads", "favorites", "recents"]).nullish(),
  has_access: z.boolean().optional(),
  has_high_res_illo: z.boolean().optional(),
  has_joined: z.boolean().nullable().optional(),
  has_video: z.boolean().optional(),
  id: z.number(),
  images: imagesSchema,
  in_kids_library: z.boolean().optional(),
  is_album: z.boolean(),
  is_completed: z.boolean().optional().nullable(),
  is_daily: z.boolean().optional(),
  is_weekly: z.boolean().optional(),
  paid: z.boolean(),
  place_in_line: z.number().nullable().optional(),
  prayers_count: z.number(),
  progress: z.float64().nullable(),
  sessions: z.string().nullable(),
  short_desc: z.string(),
  state: z
    .object({
      completed: collectionCompletedStateEnum.nullable(),
    })
    .optional()
    .nullable(),
  style_id: z.number().optional(),
  supertitle: z.string(),
  title: z.string(),
  type: z.enum(["challenge", "default"]),
  users_count: z.number().nullable().optional(),
});

export type BaseCollection = z.infer<typeof baseCollectionSchema>;
